export const FEATURE_FLAG_CALENDAR_VIEW = "calendarView"
export const FEATURE_FLAG_WEEK_VIEW = "weekView"
export const FEATURE_FLAG_GRID_VIEW = "gridView"
export const FEATURE_FLAG_PLANNING = "plan"
